import React from 'react';
import { FONTS } from '../../styles/tokens';

interface DeployActionsProps {
  isDark: boolean;
  borderColor: string;
  textSecondary: string;
  appName: string;
  onDeploy: () => void;
  onReset: () => void;
}

/**
 * Deploy button + "change file" reset button, shown once the user has chosen
 * a zip and is ready to kick off the pipeline.
 */
export function DeployActions(props: DeployActionsProps): React.JSX.Element {
  return (
    <div style={{ display: 'flex', gap: '8px', margin: '12px 0' }}>
      <button
        onClick={props.onDeploy}
        style={{
          flex: 1,
          height: '40px',
          borderRadius: '8px',
          border: 'none',
          background: props.isDark
            ? 'linear-gradient(90deg, #0266C6, #00407D)'
            : 'linear-gradient(90deg, #01A9ED, #0165C6)',
          color: '#FFF',
          fontFamily: FONTS.heading,
          fontSize: '12px',
          letterSpacing: '0.15em',
          textTransform: 'uppercase',
          cursor: 'pointer',
        }}
      >
        Deploy {props.appName}
      </button>
      <button
        onClick={props.onReset}
        style={{
          height: '40px',
          padding: '0 16px',
          borderRadius: '8px',
          border: `1px solid ${props.borderColor}`,
          background: 'transparent',
          color: props.textSecondary,
          fontFamily: FONTS.body,
          fontSize: '12px',
          cursor: 'pointer',
        }}
      >
        Change File
      </button>
    </div>
  );
}
